import { render, staticRenderFns } from "./SidebarHomeOne.vue?vue&type=template&id=3c4ffa08"
import script from "./SidebarHomeOne.vue?vue&type=script&lang=js"
export * from "./SidebarHomeOne.vue?vue&type=script&lang=js"
import style0 from "./SidebarHomeOne.vue?vue&type=style&index=0&id=3c4ffa08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports